<template>
   <div class="container-fluid" style="margin-top:20px">
    <div class="cent" v-if="list == ''">
      暂无服务人员对接
    </div>
    <div v-for="(item,index) in list" :key="index" class="zt" v-else>
      <div class="tt">
        <span style="color:#8d8d8d;">{{item.time_complete?item.time_complete:'服务中'}}</span>
        <span style="font-size:15px;color:#01b2c2">{{item.object_name}}</span>
      </div>
      <h4 class="text-left" style="font-weight: 600;">{{item.score?'评分：'+ item.score:'暂未评分'}}</h4>
      <span class="tt" style="color:#8d8d8d;font-size:16px;">{{item.object_username}}</span>
      <!-- <div class="box">
        <button class="bbt">删除</button>
      </div> -->
      <div v-if="list1[index]==0 && item.time_complete != 0">
        <div class="start">
          <van-rate v-model="item.score" :size="22" color="#fccf0a" void-icon="star" void-color="#eee"
            @change="onChange(index)" />
          <!-- <span class="xx">{{item.xx}}</span> -->
        </div>
        <div class="col-12">
          <button class='submit_btn' @click="submit(item.id,index)">提交评分</button>
        </div>
      </div>
    </div>

    <!-- <h4 style="text-align: left;">服务信息</h4>
    <div v-for="(item,index) in list" :key="index">
      <div class="aay" style="margin-top:12px">
        <p style="width:80px;text-align: left;">需求：</p>
        <p style="text-align: left;flex: 1;">{{item.object_name}}</p>
      </div>
      <div class="aay">
        <p style="width:80px;text-align: left;">接单人：</p>
        <p style="text-align: left;flex: 1;">{{item.username}}</p>
      </div>
      <div class="aay" v-if="item.logistics == 2">
        <p style="width:80px;text-align: left;">完成时间：</p>
        <p style="text-align: left;flex: 1;">{{item.time_complete}}</p>
      </div>
      <div class="aay" v-if='item.score != 0'>
        <p style="width:80px;text-align: left;">评分：</p>
        <p style="text-align: left;flex: 1;">{{item.score}}</p>
      </div>
      <div v-else-if="item.logistics == 2">
        <h4 style="text-align: left;">评分</h4>
        <div class="start">
          <van-rate v-model="value" :size="22" color="#fccf0a" void-icon="star" void-color="#eee" @change="onChange" />
          <span class="xx">{{xx}}</span>
        </div>
        <div class="col-12">
          <button class='submit_btn' @click="submit">提交评分</button>
        </div>
      </div>
    </div> -->
    <div id="d_p"></div>
    <pop :show5="showji" message="请先点亮小星星" @editshow="editshow" />
    <pop :show5="show5" message="评分成功" @editshow="editshow1" />
  </div>
</template>
<script>
import pop from './popup.vue'
export default {
  data () {
    return {
      // pingjia: false,
      showji: false,
      value: 0,
      xx: '',
      comment: '',
      list: [],
      list1: [],
      show5: false
    }
  },
  components: {
    pop
  },
  props: {
  },
  created () {
  },
  mounted () {
    this.$api.getAPI("mutual/task/?type_id=10001", {
      key_id: this.$route.query.id,
    }).then(res => {
      this.list = res.data.data.data[0].models
      for (let i = 0; i < this.list.length; i++) {
        this.list1.push(res.data.data.data[0].models[i].score)
      }
      // this.list1 = res.data.data.data[0].models
      this.aa(this.list)
      // console.log(res.data.data.data[0].models);
    })
  },
  methods: {
    aa (list) {
      console.log(list);
      for (let i = 0; i < list.length; i++) {
        if (list[i].time_complete == 0) {
        } else {
          var date = new Date(list[i].time_complete * 1000);
          var Y = date.getFullYear() + '-';
          var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
          var D = date.getDate() + ' ';
          var h = date.getHours() + ':';
          var m = date.getMinutes() + ':';
          var s = date.getSeconds();
          this.list[i].time_complete = Y + M + D + h + m + s
        }
      }
    },
    editshow () {
      this.showji = false
      // this.$router.push('/home_help')
    },
    editshow1 () {
      this.show5 = false
      // this.$router.push('/home_help')
    },
    submit (id, index) {
      if (this.list[index].score == 0) {
        this.$Message.error("请先点亮小星星！")
        // this.showji = true
      } else {
        // console.log(this.list[index].score);
        let data = new FormData()
        data.append('score', this.list[index].score)
        data.append('state', 1)
        // data.append('openid', window.localStorage.getItem('openid'))
        this.$api.postAPI(
          `mutual/task/` + id + `?appid=202108&type_id=10001`,
          data).then(res => {
            console.log(res);
            //this.showji = true
            this.$router.push('/user_help_list')
            this.$Message.success("评分成功！")
          })
        // this.$axios({
        //   method: "POST",
        //   // app/mutual/order/?appid=202108&type_id=10001&state=1
        //   url: `app/mutual/task/` + id + `?appid=202108&type_id=10001`,
        //   data: data,
        // }).then(res => {
        //   console.log(res);
        //   // this.show5 = true
        //   this.$router.push('/user_help_list')
        //   this.$Message.success("评分成功！")
        //   // alert('成功接单')
        //   // this.$router.push('/user_server_list')
        // })
      }

    },
    onChange (value, index) {
      if (value == 5) {
        this.xx = '非常好'
      }
      if (value == 4) {
        this.xx = '很好'
      }
      if (value == 3) {
        this.xx = '好'
      }
      if (value == 2) {
        this.xx = '一般'
      }
      if (value == 1) {
        this.xx = '差'
      }
      // console.log('当前值：' + value);
    },
  }


}
</script>
<style>
.start i {
  top: 0;
  right: 0;
}
.cent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #777;
  font-size: 20px;
}
.zt {
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 15px 15px;
  margin-bottom: 20px;
  background: #f9f9f9;
}
.box {
  display: flex;
  justify-content: flex-end;
}
.bbt {
  color: #4a4a4a;
  border: 1px solid #bbbbbb;
  padding: 2px 15px;
  border-radius: 16px;
  background: none;
}
.tt {
  display: flex;
  justify-content: space-between;
}
p {
  font-size: 14px;
}
.aay {
  display: flex;
}
input {
  border: 1px solid #bbbbbb;
  border-radius: 5px;
  padding-left: 8px;
}
.z_15 {
  font-size: 15px;
}
.submit_btn {
  margin-top: 20px;
  bottom: 0;
  width: 100%;
  border: 0;
  text-align: center;
  line-height: 3em;
  font-size: 1em;
  color: #ffffff;
  background: #01b2c2;
  cursor: pointer;
}
.jumbotron_a {
  color: #fff;
  background: #01b2c2;
}
.label_50 {
  border-radius: 50px/50px;
}
.jumbotron_b {
  color: #fff;
  background: #3480fa;
}

.jumbotron_c {
  background: #f3f4f8;
}
.row {
  margin-right: -15px;
  margin-left: -15px;
}
.col-12 {
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
.h5_t_5 {
  margin-top: 15px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.blockquote-footer {
  text-align: left !important;
  display: block;
  font-size: 80%;
  color: #6c757d;
}
.text-right {
  text-align: right !important;
}
.label-primary {
  color: #3480fa;
  background-color: #ffd986;
}

.label-primary-j {
  color: #fff;
  background-color: #00a4b7;
  border-radius: 15px 0px 0px 0px;
}
textarea {
  padding: 8px;
  border: 1px dashed #e5e5e5;
}
.start {
  margin-top: 12px;
  display: flex;
  /* height: 27px;
  line-height: 27px; */
}
.xx {
  font-size: 14px;
  color: #fccf0a;
  margin-left: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/user_help_comment.vue